import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '@/views/Login'
import Layout from '@/views/Layout'
import Nopage from '@/views/Exception/404'
import serverManagement from "../views/UserBackground/ServerManagement/api/service"


Vue.use(VueRouter)
const constantRouterMap = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  }, {
    path: '',
    component: Layout,
    children: [
      {
        component: () => import('@/views/Exception/404'),
        name: "404",
        path: "/404",
      }, {
        component: () => import('@/views/Exception/403'),
        name: "403",
        path: "/403",
      }, {
        component: () => import('@/views/Exception/500'),
        name: "500",
        path: "/500",
      }
    ]
  }, {
    path: '*',
    redirect: '/404'
  }]

// 前端路由表
const constantRouterComponents = {
  Layout,// 基础页面 layout 必须引入
  Nopage,
  // 你需要动态引入的页面组件
  home: () => import('@/views/Home/index'),
  // /*营销网站设置*/
  AdvertisingManagement: () => import('@/views/SiteSettings/AdvertisingManagement/index'),
  BranchOffice: () => import('@/views/SiteSettings/BranchOffice/index'),
  Links: () => import('@/views/SiteSettings/Links/index'),
  PageContent: () => import('@/views/SiteSettings/PageContent/index'),
  WebsiteInformation: () => import('@/views/SiteSettings/WebsiteInformation/index'),
  // /*菜单*/
  UserMenuLists: () => import('@/views/Menu/UserMenuList'),
  UserMenuAdd: () => import('@/views/Menu/UserMenuAdd'),
  MenuLists: () => import('@/views/Menu/MenuList'),
  MenuAdd: () => import('@/views/Menu/MenuAdd'),
  KshRoleMenuList: () => import('@/views/Menu/KshRoleMenuList'),
  // 管理员
  AdministratorList: () => import('@/views/Administrator/AdministratorList'),
  RoleList: () => import('@/views/Administrator/RoleList'),
  //客户管理
  CustomerList: () => import('@/views/CustomerManagement/Customer'),
  Industry: () => import('@/views/CustomerManagement/Industry'),
  Letter: () => import('@/views/CustomerManagement/Letter'),
  WriteLetters: () => import('@/views/CustomerManagement/WriteLetters'),
  WriteDetails: () => import('@/views/CustomerManagement/WriteDetails'),

  FeedBack: () => import('@/views/CustomerManagement/FeedBack'),
  FeedBackDetails: () => import('@/views/CustomerManagement/FeedBackDetails'),
  QcConfig: () => import('@/views/CustomerManagement/QcConfig/index'),
  //用户后台设置
  InformationSettings: () => import('@/views/UserBackground/InformationSettings/index'),
  NotificationEmail: () => import('@/views/UserBackground/NotificationEmail/index'),
  LanguagePack: () => import('@/views/UserBackground/LanguagePack/index'),
  ManageLanguagePack: () => import('@/views/UserBackground/LanguagePack/ManageLanguagePack'),
  ServerManagement: () => import('@/views/UserBackground/ServerManagement/index'),
  VersionManagement: () => import('@/views/UserBackground/VersionManagement/index'),
  KshVersionManagement: () => import('@/views/UserBackground/KshVersionManagement/index'),
  IconLibrary: () => import('@/views/UserBackground/IconLibrary/index'),
  KshUserRoles: () => import('@/views/UserBackground/KshUserRoles/index'),
  // semalt账号管理
  SemaltList: () => import('@/views/Semalt/index'),
  // 邮件模板设置
  emailTemplate: () => import('@/views/EmailTemplate/index'),
  Semalt: () => import('@/views/Semalt/index'),
  // 邮件模板设置
  EmailTemplateList: () => import('@/views/EmailTemplate/index'),
  addTemplate: () => import('@/views/EmailTemplate/components/templateForm'),

  //模板管理
  StyleManagement: () => import('@/views/TemplateManagement/StyleManagement/index'),
  TemplateListManagement: () => import('@/views/TemplateManagement/TemplateListManagement/index'),
  ColorManagement: () => import('@/views/TemplateManagement/ColorManagement/index'),

  //新闻
  NewsManagementList: () => import('@/views/NewsManagement/index'),
  AddNewsManagement: () => import('@/views/NewsManagement/components/newForm'),
  EditNewsManagement: () => import('@/views/NewsManagement/components/newForm'),
  //询盘管理
  InquiryManagementList: () => import('@/views/InquiryManagement/index'),
  //帮助中心
  ArticleManagement: () => import('@/views/HelpCenter/ArticleManagement/index'),
  AddArticleManagement: () => import('@/views/HelpCenter/ArticleManagement/components/articleForm'),
  EditArticleManagement: () => import('@/views/HelpCenter/ArticleManagement/components/articleForm'),
  ClassifiedManagement: () => import('@/views/HelpCenter/ClassifiedManagement/index'),
  VideoManagement: () => import('@/views/HelpCenter/VideoManagement/index'),

  //新顾问
  ConsultantArticleManagement: () => import('@/views/NewConsultant/ArticleManagement/index'),
  ConsultantClassifiedManagement: () => import('@/views/NewConsultant/ClassifiedManagement/index'),
  ConsultantVideoManagement: () => import('@/views/NewConsultant/VideoManagement/index'),

  //消息管理
  MessageManagementList: () => import('@/views/MessageManagement/index'),
  AddMessageManagementList: () => import('@/views/MessageManagement/components/newForm'),
  EditMessageManagementList: () => import('@/views/MessageManagement/components/newForm'),
  //热门活动
  HotEventsList: () => import('@/views/HotEvents/index'),
  AddHotEvents: () => import('@/views/HotEvents/components/newForm'),
  EditHotEvents: () => import('@/views/HotEvents/components/newForm'),
  //网站检测设置
  AdvertisingRecords: () => import('@/views/WebsiteDetection/AdvertisingRecords/index'),
  PushMailbox: () => import('@/views/WebsiteDetection/PushMailbox/index'),
  ExternalRecommendation: () => import('@/views/WebsiteDetection/ExternalRecommendation/index'),
  Suggestions: () => import('@/views/WebsiteDetection/Suggestions/index'),
  AddSuggestions: () => import('@/views/WebsiteDetection/Suggestions/EditForm'),
  EditSuggestions: () => import('@/views/WebsiteDetection/Suggestions/EditForm'),
  UVstandard: () => import('@/views/WebsiteDetection/UVstandard/index'),
  VideoSuggestions: () => import('@/views/WebsiteDetection/VideoSuggestions/index'),
  AddVideoSuggestions: () => import('@/views/WebsiteDetection/VideoSuggestions/EditForm'),
  EditVideoSuggestions: () => import('@/views/WebsiteDetection/VideoSuggestions/EditForm'),
  //批量翻译
  ColumnTranslation: () => import('@/views/BatchTranslation/ColumnTranslation/index'),
  BatchTranslationList: () => import('@/views/BatchTranslation/BatchTranslationList/index'),
  ProductClass: () => import('@/views/BatchTranslation/ProductClass/index'),
  ProductAttributes: () => import('@/views/BatchTranslation/ProductAttributes/index'),
  NewsClass: () => import('@/views/BatchTranslation/NewsClass/index'),
  NewsList: () => import('@/views/BatchTranslation/NewsList/index'),
  CaseClass: () => import('@/views/BatchTranslation/CaseClass/index'),
  CaseList: () => import('@/views/BatchTranslation/CaseList/index'),
  SinglePageClass: () => import('@/views/BatchTranslation/SinglePageClass/index'),
  SinglePageList: () => import('@/views/BatchTranslation/SinglePageList/index'),
  FAQ: () => import('@/views/BatchTranslation/FAQ/index'),
  DownloadClass: () => import('@/views/BatchTranslation/DownloadClass/index'),
  DownloadList: () => import('@/views/BatchTranslation/DownloadList/index'),
  video: () => import('@/views/BatchTranslation/video/index'),
  certificate: () => import('@/views/BatchTranslation/certificate/index'),
  seo: () => import('@/views/BatchTranslation/seo/index'),
  TranslationOther: () => import('@/views/BatchTranslation/Other/index'),
  //设置
  ServerAge: () => import('@/views/Set/ServerAge/index'),
  SourceOfVisitors: () => import('@/views/Set/SourceOfVisitors/index'),
  Filiale: () => import('@/views/Set/Filiale/index'),
  InquiryGarbage: () => import('@/views/Set/InquiryGarbage/index'),
  //统计
  StatisticalSummary: () => import('@/views/DataStatistics/StatisticalSummary/index'),
  WebStatistics: () => import('@/views/DataStatistics/WebStatistics/index'),
  WebStatisticsDetails: () => import('@/views/DataStatistics/WebStatisticsDetails/index'),
  Active: () => import('@/views/DataStatistics/Active/index'),
  Industrys: () => import('@/views/DataStatistics/Industry/index'),
  Inquiry: () => import('@/views/DataStatistics/Inquiry/index'),
  Translate: () => import('@/views/DataStatistics/Translate/index'),
  SourceVisitors: () => import('@/views/DataStatistics/SourceVisitors/index'),
  TemplateRecord: () => import('@/views/DataStatistics/TemplateRecord/index'),
  TemplateRecordDetails: () => import('@/views/DataStatistics/TemplateRecordDetails/index'),
  ProductArticle: () => import('@/views/DataStatistics/ProductArticle/index'),
  PaymentFunction: () => import('@/views/DataStatistics/PaymentFunction/index'),
  VisitTerminal: () => import('@/views/DataStatistics/VisitTerminal/index'),
  RankVersion: () => import('@/views/DataStatistics/RankVersion/index'),
  RankType: () => import('@/views/DataStatistics/RankType/index'),
  xinshou: () => import('@/views/DataStatistics/xinshou/index'),
  tokenStatistics: () => import('@/views/DataStatistics/TokenStatistics/index'),
  CustomerPointsDetails: () => import('@/views/CustomerPoints/CustomerPointsList/components/CustomerPointsDetails'),
  CustomerPointsList: () => import('@/views/CustomerPoints/CustomerPointsList/index'),
  CustomerPointsType: () => import('@/views/CustomerPoints/CustomerPointsType/index'),

  InvitationList: () => import('@/views/Invitation/InvitationList/index'),
  InvitationSet: () => import('@/views/Invitation/InvitationSet/index'),

  Important: () => import('@/views/DataStatistics/Important/index'),
  Behavior: () => import('@/views/DataStatistics/Behavior/index'),

  OrderList: () => import('@/views/CustomerManagement/OrderList'),
  Finance: () => import('@/views/CustomerManagement/Finance'),
  PaymentSettings: () => import('@/views/Set/PaymentSettings/index'),
  Sms: () => import('@/views/Set/Sms/index'),
  BehaviorDetails: () => import('@/views/DataStatistics/BehaviorDetails/index'),
  Operate: () => import('@/views/DataStatistics/Operate/index'),
  AutomaticInquiryFiltering: () => import('@/views/Set/AutomaticInquiryFiltering/index'),

  MessagePrompt: () => import('@/views/Set/MessagePrompt/index'),
  AutomatedMarketing: () => import('@/views/DataStatistics/AutomatedMarketing/index'),
  FileManagementList: () => import('@/views/FileManagement/FileManagement/index'),

  AOrderStatisticsSJZ: () => import('@/views/DataStatistics/AOrderStatistics/AOrderStatisticsSJZ/index'),
  AOrderStatisticsTS: () => import('@/views/DataStatistics/AOrderStatistics/AOrderStatisticsTS/index'),
  AOrderStatisticsSJZDetail: () => import('@/views/DataStatistics/AOrderStatistics/AOrderStatisticsSJZ/detail'),
  AOrderStatisticsTSDetail: () => import('@/views/DataStatistics/AOrderStatistics/AOrderStatisticsTS/detail'),
  Aichat: () => import('@/views/DataStatistics/Aichat/index'),
  AiImgBank: () => import('@/views/DataStatistics/AiImgBank/index'),

  CustomTemplateList: () => import('@/views/CustomTemplate/CustomTemplateList/index'),
  CustomTemplateCate: () => import('@/views/CustomTemplate/CustomTemplateCate/index'),
  CustomTemplateGroup: () => import('@/views/CustomTemplate/CustomTemplateGroup/index'),
  addCustomTemplate: () => import('@/views/CustomTemplate/CustomTemplateList/components/templateForm'),
  AgentList: () => import('@/views/Agent/list/index'),
  BatchImportList: () => import('@/views/BatchImport/list/index'),
  AlibabaList: () => import('@/views/Alibaba/list/index'),
  BatchImport: () => import('@/views/BatchImport/list/index'),
  // Sitmap: () => import('@/views/CustomerManagement/Sitmap'),
  // AI
  smartGenerate: () => import('@/views/AI/smartGenerate/index'),
  assistant: () => import('@/views/AI/assistant/index'),
  assistantEdit: () => import('@/views/AI/assistantEdit/index'),
  contentExample: () => import('@/views/AI/contentExample/index'),
  phaseReport: () => import('@/views/AI/aiReport/phaseReport/index'),
  strategyReport: () => import('@/views/AI/aiReport/strategyReport/index'),
  googleAdsInstruction: () => import('@/views/AI/AGoogleAdsInstructions/index'),
  googleAdslandingPage: () => import('@/views/AI/AGoogleAdslandingPage/index'),
  //ksh
  ModuleCategory: () => import('@/views/ksh/ModuleCategory/index'),
  ControlCategory: () => import('@/views/ksh/ControlCategory/index'),
  Control: () => import('@/views/ksh/Control/index'),
  Module: () => import('@/views/ksh/Module/index'),
  KshTemplateListManagement: () => import('@/views/KshTemplateManagement/TemplateListManagement/index'),
  DesignerManagement: () => import('@/views/KshTemplateManagement/DesignerManagement/index'),
  KshColorManagement: () => import('@/views/KshTemplateManagement/ColorManagement/index'),
  KshStyleManagement: () => import('@/views/KshTemplateManagement/StyleManagement/index'),
  KshTemplateRecycle: () => import('@/views/KshTemplateManagement/TemplateRecycle/index'),
  Sitmap: () => import('@/views/CustomerManagement/Sitmap'),
  AInquiryIp: () => import('@/views/Set/AInquiryIp/index'),
}

export {constantRouterComponents}

const createRouter = () => new VueRouter({
  // mode:'history',
  routes:constantRouterMap
})
const router = createRouter()
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // the relevant part
}
export default router
// export default new VueRouter({
//   routes
// })
